import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { FolderManagementService } from 'src/framework/services/folder-mgmt.service';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { ModalContentComponent } from 'src/app/shared/modal-component/modal.component';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';


@Component({
  selector: 'app-manage-folder',
  templateUrl: './manage-folder.component.html',
  styleUrls: ['./manage-folder.component.css'],
  providers: [MessageService]
})

export class ManageFolderComponent implements OnInit {
  bsModalRef: BsModalRef;

  targetTreeData: TreeNode[] = [];

  maxSeed: number = 0;

  languageList: any[] = [];
  languageLabels: any[] = [];

  folderPath: "";
  selectedTargetFile: TreeNode;

  templateNode: TreeNode[];

  deleteNodeObj: TreeNode;

  clonedTree: any[] = [];
  cloneTemplateCounter: number = 0;
  isValid: boolean = false;
  inValidFieldCounter: number = 0;
  isEditable: boolean = false;
  fileCounter: number = 0;
  folderCounter: number = 0;
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  };
  appLanguageList: any[] = [];
  sortingTypeList: any[] = [];
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  selectedLangSortJson: any;
  defaultEngSortJson: any;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  localeSetting: any;

  constructor(private folderService: FolderManagementService, private messageService: MessageService,
    private labelCardService: LabelcardMgmtService, private spinner: NgxSpinnerService,
    private languageService: LanguageService, private modalService: BsModalService
  ) {
    this.sortingTypeList = [
      { label: 'Alphabetical Order (ASC)', value: '1' },
      { label: 'Chronological Order (DESC)', value: '2' },
      { label: 'Chrono,Alpha Order (DESC)', value: '4' },
      { label: 'Manual', value: '3' }
    ];
  }

  public ngOnInit() {


    this.initializeEngagementData()
      .then(res => {
        this.loadLanguageLabel()
          .then(res => {
            this.initializeSortList();
            this.getFolderStructure()
          })
          .catch(err => {
            console.log(err);
          })
      })
      .catch(err => {
        console.log(err);
      });

  }

isMobileDevice = function () {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('EdgA') !== -1);
};

  initializeEngagementData() {

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLanguageList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }
      else {
        this.preLoadData();
      }

      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));
      }
      resolve(1);
    });
  }

  initializeSortList() {
    this.sortingTypeList = [
      { label: this.sortTypeReplacer('1'), value: '1' },
      { label: this.sortTypeReplacer('2'), value: '2' },
      { label: this.sortTypeReplacer('4'), value: '4' },
      { label: this.sortTypeReplacer('3'), value: '3' }
    ];
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;
    let englishSortMappings, selectedLangSortMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedAppLanguage = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.ManageFolder.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishSortMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.SortTypes.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];


          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.ManageFolder.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangSortMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.SortTypes.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.ManageFolder.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangSortMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.SortTypes.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
              selectedLangSortMappings = englishSortMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangSortJson = JSON.parse(selectedLangSortMappings?.languageMappingJSON ?? englishSortMappings.languageMappingJSON);
          this.defaultEngSortJson = JSON.parse(englishSortMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.setCalendarLocale();

          this.islabelLoaded = true;
          this.spinner.hide();
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }

  omit_special_char(event) { 
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)    
    //return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); }
    return(k != 47 && k != 92 && k != 58 && k != 42 && k != 63 && k!= 34 && k != 60 && k!= 62 && k != 124); }
    

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }

  sortTypeReplacer(labelKey): string {
    return this.selectedLangSortJson[labelKey]?.trim() ? this.selectedLangSortJson[labelKey] ?? 'text not found' : this.defaultEngSortJson[labelKey] ?? 'text not found';
  }

  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }

  get globalIdentitySeed() {

    if (this.targetTreeData.length > 0) {

      this.targetTreeData.forEach(node => {
        this.getMaxSeedValue(node);
      });
    }

    return this.maxSeed;
  }

  set globalIdentitySeed(value) {
    this.maxSeed = value;
  }

  getMaxSeedValue(node: TreeNode) {

    if (this.maxSeed < Number(node.key)) {
      this.maxSeed = Number(node.key);
    }
    if (node.children) {
      node.children.forEach(childNode => {
        this.getMaxSeedValue(childNode);
      });
    }

  }

  public preLoadData() {

    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLanguageList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }

          });
        } else {
          //display error
        }
        resolve(1);

      });
    });

  }

  getFolderStructure() {
    this.spinner.show();
    this.targetTreeData = [];
    this.languageList = this.engagementDetail.engLanguage; //language list will be mapped from engagement langauge
    this.folderService.getFolderTemplate(this.engagementDetail.engagementId).then(files => {
      var count: Array<number>=[];
      if (files.length > 0 && files[0].children) {
        let i =0;
        files[0].children.forEach(childNode => {
        if(childNode == null || childNode.label==undefined)
        {
          count.push(i);
        }
        i = i+1;
      });
      }
      
      count.forEach( val =>{
        files[0].children.splice(val,1);
      });
      this.targetTreeData = files.length > 0 ? files : []
      this.preProcessTree();
      this.clonedTree = _.cloneDeep(this.targetTreeData);
      this.spinner.hide();
    });

  }

  preProcessTree() {
    this.targetTreeData.forEach(x => {
      this.preProcessTreeRecursive(x)
    });
  }

  preProcessTreeRecursive(node: TreeNode) {
    if (node != null && node != undefined) {
      if (node?.type.toLowerCase() === 'file') {
        if (this.isMobileDevice()) { //disable drag n drop for mobile Edge until
          // primeng issue of drag drop is fixed in future versions
          node.draggable = false;
          node.droppable = false;
        }
        else {
        node.draggable = true;
        node.droppable = false;
        }
      }
      else if (node?.type.toLowerCase() === 'folder') {
        if (this.isMobileDevice()) { //disable drag n drop for mobile Edge until
          // primeng issue of drag drop is fixed in future versions
          node.draggable = false;
          node.droppable = false;
        }
        else {
        //update flags
        node.draggable = true;
        node.droppable = true;
        }

        this.computeFolderLangLabel(node, 'nodeAdd');
        this.sortNode(node);
      }
      else if (node?.type.toLowerCase() === 'structure') {
        this.sortNode(node);
      }

      if (node?.children?.length > 0) {
        //toggle display of expand/collapse arrow
        if (node.type.toLowerCase() === 'folder') {
          if (node?.children?.some(x => x.type?.toLowerCase() === 'folder')) {
            node.styleClass = 'childFolder';
          }
          else {
            node.styleClass = 'childFolder hideArrowClass';
          }
        }

        node.children.forEach(childNode => {
          this.preProcessTreeRecursive(childNode);
        });
      }
    }

  }

  sortNode(node: TreeNode) {

    if (!('sortTypeId' in node?.data[0])) {
      node.data[0]['sortTypeId'] = '2';
    }

    if (node?.data[0]?.sortTypeId.toString() === '1') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children?.length > 0) {
        node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        // node?.children.forEach(childNode => {
        //   childNode.draggable = false;
        //   childNode.droppable = false;
        // });
      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '2') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children?.length > 0) {
        node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.date_sort_desc(a, b));

        // node?.children.forEach(childNode => {
        //   childNode.draggable = false;
        //   childNode.droppable = false;
        // });
      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '3') {

    }
    else if (node?.data[0]?.sortTypeId.toString() === '4') {
      node?.children?.sort((a, b) => b.label?.localeCompare(a.label));
      node?.children?.sort((a, b) => this.date_sort_desc(a, b));
    }
  }



  date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    let res;
    if (a?.type?.toLowerCase() === 'file') {
      a = new Date(a?.data[0]?.documentDate).getTime() ?? new Date(a?.data[0]?.createdDTTM).getTime();
    }
    else {
      a = new Date(a?.data[0]?.createdDTTM).getTime();
    }

    if (b?.type?.toLowerCase() === 'file') {
      b = new Date(b?.data[0]?.documentDate).getTime() ?? new Date(b?.data[0]?.createdDTTM).getTime();
    }
    else {
      b = new Date(b?.data[0]?.createdDTTM).getTime();
    }

    res = a > b ? -1 : a < b ? 1 : 0;

    return res;
  };

  getChildCount(childType, node) {
    let nodeType = childType.toLowerCase();
    const msgStr = this.labelReplacer('ttFileCount') + ": ";
    this.fileCounter = 0;
    this.folderCounter = 0;
    if (node !== undefined && node !== null) {
      if (node.children.length > 0) {
        node.children?.forEach(childNode => {
          this.recursiveChildCount(childNode);
        });
        return msgStr + this.fileCounter;
      }
      return msgStr + "0";
    }
    return msgStr + "0";
  }

  recursiveChildCount(node: TreeNode) {
    if (node.type.toLowerCase() === 'file')
      this.fileCounter++;
    else if (node.type.toLowerCase() === 'folder')
      this.folderCounter++;
    if (node.children) {
      node.children.forEach(childNode => {
        this.recursiveChildCount(childNode);
      });
    }
  }

  validateTree() {

    if (this.targetTreeData.length > 0) {
      this.inValidFieldCounter = 0; //reset counter
      this.targetTreeData.forEach(node => {
        this.checkTreeRecursive(node);
      });

      let isDuplicate = this.findDuplicate();
      this.inValidFieldCounter > 0 || isDuplicate ? this.isValid = false : this.isValid = true;
    }
  }

  checkTreeRecursive(node: TreeNode) {

    if (node == undefined || node == null) {
      this.inValidFieldCounter++;
      return;
    }

    if (node.label?.trim() === '') {
      this.inValidFieldCounter++;
    }
    if (node.children) {
      node.children.forEach(childNode => {
        this.checkTreeRecursive(childNode);
      });
    }
  }



  computeFolderLangLabel(node, operation) {
    //Build array for modal
    var searchObj = null;
    let nodeLangList: any[] = this.languageList;
    this.languageLabels = [];
    this.templateNode = [];
    this.templateNode = node;

    // if (node?.type === 'structure') {
    //   nodeLangList = [];
    //   // nodeLangList.push(this.languageList.filter(x => x.languageId === 1)[0]); //english
    //   // nodeLangList.push(this.languageList.filter(x => x.languageId === 2)[0]); //french
    // }

    if (nodeLangList.length > 0) {
      nodeLangList.forEach(element => {

        if (node.data[0]?.language?.length > 0) {

          searchObj = node.data[0]['language'].filter(x => Number(x.languageId) === Number(element.languageId))[0];
          if (searchObj) {

            this.languageLabels.push({
              languageId: searchObj.languageId,
              languageName: searchObj.languageName,
              languageFlagPath: searchObj.languageFlagPath,
              folderName: searchObj.folderName,
              languageFlagCssClass: searchObj.languageFlagCssClass
            });
          }
          else {

            this.languageLabels.push({
              languageId: element.languageId,
              languageName: element.languageName,
              languageFlagPath: element.languageFlagPath,
              folderName: '',
              languageFlagCssClass: 'flag-fade-out'
            });
          }

        }

        else {
          this.languageLabels.push({
            languageId: element.languageId,
            languageName: element.languageName,
            languageFlagPath: element.languageFlagPath,
            folderName: '',
            languageFlagCssClass: 'flag-fade-out'
          })
        }

      });

      if (operation === 'nodeAdd') this.saveFolderLabel();

    }
    else {
      this.languageLabels = [];
    }

  }

  onLabelLoad(folderType): boolean {
    let element = null;
    if (folderType?.toLowerCase() == 'root')
      element = document.getElementById("elasticInpRoot");
    // else if (folderType?.toLowerCase() == 'folder')
    else
      element = document.getElementById(folderType);

    if (element !== null && element !== undefined) {
      element.style.width = ((element.value.length + 1) * 8) + 'px';
    }

    return true;
  }


  onLabelChange(node, event) {

    let ev = event;
    if (ev !== null && ev !== undefined) {
      ev.srcElement.style.width = ((ev.srcElement.value.length + 1) * 8) + 'px';
    }
    let langArray = node['data'][0]['language'];
    let langEnglish = langArray.filter(x => Number(x.languageId) === 1)[0];

    if (node.label && node.label?.trim() !== '') {
      node.label = node.label?.trim();
      if (langEnglish) {
        langEnglish.folderName = node.label?.trim();
        langEnglish["languageFlagCssClass"] = "";
      }
    }
    else {
      if (langEnglish) {
        langEnglish.folderName = node.label;
        langEnglish["languageFlagCssClass"] = "flag-fade-out"
      }
    }

  };


  saveFolderLabel() {
    this.languageLabels.forEach(lang => {
      lang["languageId"] = lang["languageId"].toString();
      if (lang["folderName"] != "" && lang["folderName"] != null) {
        lang["languageFlagCssClass"] = ""
      } else {
        lang["languageFlagCssClass"] = "flag-fade-out"

      }
    });

    if (this.templateNode?.['data'].length > 0) {
      this.templateNode['data'][0]['language'] = this.languageLabels;
    }
    else {
      this.templateNode['data'] = [{
        'language': this.languageLabels
      }]
    }

  }



  addNode(node) {
    if (node) {
      if (node.label) {
        node.children.push({
          label: "",
          key: Date.now().toString(),//(++this.globalIdentitySeed).toString(),
          type: "folder",
          data: [{
            "createdDTTM": new Date().toDateString(),
            "sortTypeId": '2'
          }],
          expandedIcon: "pi pi-folder-open",
          collapsedIcon: "pi pi-folder",
          styleClass: "childFolder",
          children: []
        } as TreeNode);


        this.computeFolderLangLabel(node.children[node.children.length - 1], 'nodeAdd');
        this.sortNode(node);
        node.expanded = true;
      }
      else {
        this.messageService.add({
          summary: this.labelReplacer('msgWarningType'),
          detail: this.labelReplacer('msgErrorAddingFolder'),
          sticky: false,
          severity: 'warning'
        });
      }
    }
  }

  copyNode(node) {
    // if (node.children.length > 0) {
    //   var returnVal = this.verifyNodeBeforeDelete(node);
    //   if (returnVal == false) {
    //     this.deleteNodeObj = node;
    //   }
    //   else {
    //     this.messageService.add({
    //       summary: this.labelReplacer('msgErrorType'),
    //       detail: this.labelReplacer('msgBlankOrDuplicateFolder'),
    //       sticky: false,
    //       severity: 'error'
    //     });
    //   }
    // } else {
    this.deleteNodeObj = node;
    //}
  }

  verifyNodeBeforeDelete(node: TreeNode): boolean {
    var returnValue = false
    node.children.forEach(element => {
      if (element.type.toLowerCase() === 'file') {
        returnValue = true;
        return returnValue;
      }
      else if (element.children.length > 0 && element.type.toLowerCase() === 'folder') {
        returnValue = this.verifyNodeBeforeDelete(element);
        return returnValue;
      }
    });
    return returnValue;
  }

  deleteNode(node) {
    if (this.deleteNodeObj) {
      let node = this.deleteNodeObj;
      if (node && node.parent) {
        let index = node.parent.children.indexOf(node);
        node.parent.children.splice(index, 1);
      }
      else {
        let index = this.targetTreeData.indexOf(node);
        this.targetTreeData.splice(index, 1);
      }
      this.deleteNodeObj = null;

    }

  }


  nodeSelect(event) {
  }

  nodeDrop(event) {
    // event.dropNode.droppable = undefined;
    // const initialState = {
    //   list: [
    //     {"value": event.dragNode.label}
    //   ]
    // };

    // this.bsModalRef = this.modalService.show(ModalContentComponent,{initialState});
    // this.bsModalRef.content.event.subscribe(res => {
    //     if(res.data){
    //       event.accept();
    //       event.dropNode.expanded = true;
    //     }
    // });
    event.dropNode.expanded = true;
  }

  sortTree() {
    return new Promise((resolve, reject) => {
      this.targetTreeData.forEach(x => {
        this.sortRecursive(x)
      });
      resolve(1);
    });
  }

  sortRecursive(node: TreeNode) {
    if (node.type.toLowerCase() === 'folder' || node.type.toLowerCase() === 'structure') {
      this.sortNode(node);
    }
    if (node.children?.length > 0) {
      node.children.forEach(childNode => {
        this.sortRecursive(childNode);
      });
    }
  }


  saveTree() {

    this.spinner.show();
    this.validateTree();
    if (this.isValid) {
      this.sortTree()
        .then(res => {
          this.folderService.saveFolderTemplate(this.targetTreeData, this.engagementDetail.engagementId).subscribe(res => {
            if (res.status === 0) {
              //success
              this.isEditable = false;
              this.clonedTree = _.cloneDeep(this.targetTreeData);
              this.messageService.add({
                summary: this.labelReplacer('msgSuccessType'),
                detail: this.labelReplacer('msgSaveSucess'),
                sticky: false,
                severity: 'success'
              });
            } else {
              //display error
              this.messageService.add({
                summary: this.labelReplacer('msgErrorType'),
                detail: res.message,
                sticky: false,
                severity: 'error'
              });
            }

            this.spinner.hide();

          });
        })
        .catch(error => {
          console.log(error);
          this.spinner.hide();
        });

    }
    else {
      this.spinner.hide();
      this.messageService.add({
        summary: this.labelReplacer('msgErrorType'),
        detail: this.labelReplacer('msgBlankOrDuplicateFolder'),
        sticky: false,
        severity: 'error'
      });
    }
  }

  resetTree() {
    this.targetTreeData = _.cloneDeep(this.clonedTree);
  }

  expandAll() {
    this.targetTreeData.forEach(node => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.targetTreeData[0]?.children.forEach(node => {
      this.expandRecursive(node, false);
    });
  }



  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  changeFolderDate(selectedDate, node) {
    if (selectedDate) {
      node.data[0].createdDTTM = selectedDate.toDateString();
    }
  }

  // Start function
  findDuplicate(): boolean {
    let isDuplicate = false;
    let duplicateNode: TreeNode = {};
    let labelArr: any[] = [];

    function recurseFindDuplicate(searchTree) {

      for (var i = 0; i < searchTree.length; i++) {
        if (isDuplicate) {
          break;
        }
        // Are there children / sub-categories? YES
        if (searchTree[i].children.length > 0) {
          labelArr = searchTree[i]?.children?.filter(x => x.type.toLowerCase() === 'folder')?.map(function (item) { return item.label });
          isDuplicate = labelArr.some(function (item, idx) {
            return labelArr.indexOf(item) != idx
          });
          if (isDuplicate) {
            break;
          }
          recurseFindDuplicate(searchTree[i].children);

        }
      }

    }

    recurseFindDuplicate(this.targetTreeData);

    return isDuplicate;
  }

  getFlagTooltip(langObj): string {
    let tooltipMsg = this.labelReplacer('ttFlagDefault');
    if (langObj) {
      if (langObj?.folderName !== undefined && langObj?.folderName !== null && langObj?.folderName?.trim() !== '') {
        tooltipMsg = langObj.folderName;
      }
      return tooltipMsg;
    }
  }

}
